// src/services/vendorApi.ts
import { api } from "@/services/api";

// ===============================
// TYPES
// ===============================
export interface VendorRequest {
  vendorName: string;
  contactPersonName: string;
  contactEmail: string;
  contactPhone: string;
  businessAddress: string;
  city: string;
  state: string;
  zipCode: string;
  status: "ACTIVE" | "INACTIVE" | "SUSPENDED";
  
  appointmentRequirement?: string;
  servicesScope?: string;
  pricingModel?: string;
  cocRequirement?: string;
  uniformOperatingHours?: string; // JSON string
  uniformTestConfiguration?: string; // JSON string
  acceptsMedigenixForm?: boolean;
  resultDeliveryMethod?: string;
  resultDeliveryDetails?: string;
  accountNumbers?: string; // JSON string array
  collectionFeeConfiguration?: string; // JSON string
  uniformDrugConfiguration?: string; // JSON string
  marginConfiguration?: string; // JSON string
  
  // Legacy field support
  accountNumber?: string;
}


export interface Vendor extends VendorRequest {
  id: number;
  locationCount?: number;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

// ===============================
// API ENDPOINTS
// ===============================
export const vendorApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE VENDOR
    createVendor: builder.mutation<Vendor, VendorRequest>({
      query: (body) => ({
        url: "/super-admin/vendors",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Vendors"],
    }),

    // UPDATE VENDOR
    updateVendor: builder.mutation<
      Vendor,
      { id: number; data: Partial<VendorRequest> }
    >({
      query: ({ id, data }) => ({
        url: `/super-admin/vendors/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Vendors"],
    }),

    // LIST VENDORS
    listVendors: builder.query<Vendor[], void>({
      query: () => ({
        url: "/super-admin/vendors",
        method: "GET",
      }),
      providesTags: ["Vendors"],
    }),

    // GET VENDOR BY ID
    getVendorById: builder.query<Vendor, number>({
      query: (id) => ({
        url: `/super-admin/vendors/${id}`,
        method: "GET",
      }),
      providesTags: ["Vendors"],
    }),

    // DELETE VENDOR
    deleteVendor: builder.mutation<{ message: string }, number>({
      query: (id) => ({
        url: `/super-admin/vendors/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Vendors"],
    }),
  }),
});

// ===============================
// AUTO GENERATED HOOKS
// ===============================
export const {
  useCreateVendorMutation,
  useUpdateVendorMutation,
  useListVendorsQuery,
  useGetVendorByIdQuery,
  useDeleteVendorMutation,
} = vendorApi;
